import API from '@/services/api';

// Actions
export const FETCH_COMPANIES = 'fetchCompanies';
export const FETCH_ALL_COMPANIES = 'fetchAllCompanies';
export const FETCH_COMPANY = 'fetchCompany';
export const CREATE_COMPANY = 'createCompany';
export const UPDATE_COMPANY = 'updateCompany';
export const DELETE_COMPANY = 'deleteCompany';

// Mutations
export const STORE_SET_COMPANIES = 'storeSetCompanies';
export const STORE_ADD_COMPANY = 'storeAddCompany';
export const STORE_UPDATE_COMPANY = 'storeUpdateCompany';
export const STORE_DELETE_COMPANY = 'storeDeleteCompany';

// Only the latest request may update the list, so slow responses for older search terms are ignored
let latestCompaniesRequest = 0;

const state = {
    companies: {
        data: [],
        meta: {
            total: 0,
            per_page: 15,
            from: 1,
            to: 0,
            current_page: 1
        }
    }
};

const getters = {
    companies(state) {
        return state.companies;
    }
};

const actions = {
    [FETCH_COMPANIES](context, options) {
        const request = ++latestCompaniesRequest;
        let query = 'companies?page=' + options.page;

        if (options.search) {
            query += '&search=' + encodeURIComponent(options.search);
        }

        return new Promise((resolve, reject) => {
            API
                .query(query)
                .then((response) => {
                    if (request === latestCompaniesRequest) {
                        context.commit(STORE_SET_COMPANIES, response.data);
                    }
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    },
    [FETCH_ALL_COMPANIES]() {
        return new Promise((resolve, reject) => {
            API
              .query('companies')
              .then((response) => {
                  resolve(response.data);
              })
              .catch((response) => {
                  reject(response);
              });
        });
    },
    [FETCH_COMPANY](context, company) {
        return new Promise((resolve, reject) => {
            API
                .query('companies/' + company)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    },
    [CREATE_COMPANY](context, company) {
        return new Promise((resolve, reject) => {
            API
                .post('companies', company)
                .then((response) => {
                    context.commit(STORE_ADD_COMPANY, response.data);
                    resolve(response.data);
                })
                .catch(({response}) => {
                    reject(response.data);
                });
        });
    },
    [UPDATE_COMPANY](context, object) {
        return new Promise((resolve, reject) => {
            API
                .update('companies', object.id, object.changes)
                .then((response) => {
                    context.commit(STORE_UPDATE_COMPANY, response.data);
                    resolve(response.data);
                })
                .catch(({response}) => {
                    reject(response.data);
                });
        });
    },
    [DELETE_COMPANY](context, company) {
        return new Promise((resolve, reject) => {
            API
                .delete('companies/' + company.id)
                .then((response) => {
                    context.commit(STORE_DELETE_COMPANY, company);
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response)
                });
        });
    }
};

const mutations = {
    [STORE_SET_COMPANIES](state, companies) {
        state.companies = companies;
    },
    [STORE_ADD_COMPANY](state, company) {
        state.companies.data.push(company);
    },
    [STORE_UPDATE_COMPANY](state, company) {
        let companies = [];

        state.companies.data.map((mapCompany) => {
            if (mapCompany.id === company.id) {
                mapCompany = company;
            }

            companies.push(mapCompany);
        });

        state.companies.data = companies;
    },
    [STORE_DELETE_COMPANY](state, company) {
        state.companies.data.splice( state.companies.data.indexOf(company), 1 );
    }
};

export default {state, getters, actions, mutations}